import { render, staticRenderFns } from "./GameResult.vue?vue&type=template&id=07fabdc9&"
import script from "./GameResult.vue?vue&type=script&lang=js&"
export * from "./GameResult.vue?vue&type=script&lang=js&"
import style0 from "./GameResult.vue?vue&type=style&index=0&id=07fabdc9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports